import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { UserService } from '../../services/user.service';
import {
  FormBuilder,
  FormControl,
  FormArray,
  FormGroup,
  Validators,
  NgForm,
} from '@angular/forms';
import { EnquireService } from '../../services/enquire.service';
import { ChangeDetectorRef } from '@angular/core';
import { StorageService } from '../../services/storage.service';
import { decode } from 'base64-arraybuffer';
import { register } from 'swiper/element/bundle';
import { NotificationService } from '../../services/notification.service';
import { firstValueFrom, Subject, takeUntil, interval, map, distinctUntilChanged, filter, forkJoin, debounceTime } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PurchaseReturnModalComponent } from '../purchase-return-modal/purchase-return-modal.component';
import { ChatModalComponent } from '../chat-modal/chat-modal.component';
import { AttachmentModalComponent } from '../attachment-modal/attachment-modal.component';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ConfirmDialogComponent } from '../shared/confirm-dialog/confirm-dialog.component';
import { AddressSelectionModalComponent } from '../shared/address-selection-modal/address-selection-modal.component';
import { LoadingService } from '../../services/loading.service';
import { RegenerateItemModalComponent } from '../shared/regenerate-item-modal/regenerate-item-modal.component';

register();

interface ExcelRow {
  [key: string]: any;
  partNo?: string;
  partDescription?: string;
  qty?: number | string;
}
@Component({
  selector: 'app-enquiry-detail',
  templateUrl: './enquiry-detail.component.html',
  styleUrls: ['./enquiry-detail.component.scss'],
})
export class EnquiryDetailComponent implements OnInit {
  private destroy$ = new Subject<void>();
  private destroyLoader$ = new Subject<void>();
  editMode: any;
  addresses: any;
  uploading: boolean;
  locationSub: any;
  vehDetails: any;
  paramPassEnqId: any;
  isLoading = false;
  orderAvailable = true;
  partDetailsLoaded = false;
  curPartId: any;
  showQueryModal: boolean = false;
  basicDetails: any;
  basicDetailsLoaded: any = false;
  Object = Object;
  selectedPrices: {
    [key: string]: {
      id: number;
      brand: string;
      price: number;
      landingPrice: number;
      sellingPrice: number;
      qty: number;
      sellerId?: number;
      type?: number;
    };
  } = {};
  selectedReturnParts: {
    [key: string]: { id: number };
  } = {};
  debitNote = {
    no: '',
    id: '',
    url: '',
  };
  podDoc = {
    id: '',
    url: '',
  };
  selectedQueryType: string;
  querys: any[] = [];
  totalAmount: number;
  totalSavings: number = 0;
  accType: string;
  partPriceList: {
    [partId: number]: {
      brand: string;
      price: number;
      type: number;
      qty: number;
      deliveryTime?: number;
    }[];
  } = {};
  QueryForm = new FormGroup({
    type: new FormControl(''),
    remarks: new FormControl(''),
  });
  selectedVehicleAttachmentType: string;
  selectedDocAttachmentType: string;
  vehicleAttachmentList: any[] = [];
  docAttachmentList: any[] = [];
  poDocument: { name: string; file: any } | null = null;
  updatedPartDetails: { enquiryPartId: number; partNo: string }[] = [];
  vehAttDetails: any;
  private previousEnquiryId: number | null = null;

  templateDownloaded = false;
  excelDataLoaded = false;
  excelPreview: ExcelRow[] = [];
  columns: string[] = [];

  excelModalForm: FormGroup;
  excelModalFormArray!: FormArray;

  showExcelModal = false;
  selectedExcelFile: File | null = null;
  excelDataFetched: boolean = false;
  selectedAddress: any;
  pickupAddressId!: number;
  deliveryType!: number;
  deliveryTypeStr!: string;
  deliveryTime!: string;
  serviceError: string | null = null;
  isOtpComplete = false;
  isServiceable = false;
  boxDetails: any;
  showErrorBanner = false;
  reqType: string = '1';
  isInitialLoading = true;

  // Fancy loader state (ADD THESE)
  loaderTips: string[] = [
    'Preparing enquiry',
    'Fetching details',
    'Loading parts',
    'Almost there',
  ];
  loaderTipIndex = 0;
  loaderProgress = 0;

  oesBrandList: { id: number; title: string }[] = [];

  selectedGlobalSellerId: number | null = null;

  editPartForm: FormGroup;
  selectedPart: any = null;
  selectedPartIndex: number = null;
  editError: string = '';
  partItemsList: any[] = [];
  showPartSuggestions: boolean = false;
  partSearchLoading: boolean = false;
  searchTimeout: any;

  editedParts: {
    enquiryPartId: number;
    quotationPartId: number;
    partNo: string;
    qty: number;
    make: string;
  }[] = [];

  @ViewChild('excelPreviewModal') excelPreviewModal: TemplateRef<any>;
  @ViewChild('editPartModal') editPartModal: TemplateRef<any>;

  constructor(
    private formBuilder: FormBuilder,
    private user: UserService,
    private route: ActivatedRoute,
    public router: Router,
    private enq: EnquireService,
    private cdr: ChangeDetectorRef,
    private http: ApiService,
    private store: StorageService,
    private notify: NotificationService,
    private modalService: NgbModal,
    private loadingService: LoadingService
  ) {
    try {
      const rawAccType = this.store.get('acc_type');
      this.accType =
        rawAccType !== undefined && rawAccType !== null
          ? rawAccType.toString()
          : '';
      console.log('riyas', this.accType, typeof this.accType); // should log string
    } catch (error) {
      console.error('Error retrieving or parsing acc_type:', error);
    }

    this.initializeBasicForm();
  }

  vehicleDocList = [
    {
      id: 1,
      value: 'Vehicle Rc Copy',
    },
    {
      id: 2,
      value: 'Vehicle Front Photo',
    },
    {
      id: 3,
      value: 'Vehicle Rear Photo',
    },
    {
      id: 4,
      value: 'Vehicle Side Photo',
    },
    {
      id: 5,
      value: 'Parts Photo',
    },
  ];
  orderDocQueryList = [
    {
      id: 2,
      value: 'Invoice',
    },
    {
      id: 3,
      value: 'E-Way Bill',
    },
    {
      id: 4,
      value: 'POD Copy',
    },
  ];
  orderDocQueryLists = [
    {
      id: 2,
      value: 'Invoice',
    },
    {
      id: 3,
      value: 'E-Way Bill',
    },
    {
      id: 4,
      value: 'POD Copy',
    },
  ];

  queryList = [
    {
      id: '1',
      value: 'Vehicle Rc Copy',
    },
    {
      id: '2',
      value: 'Vehicle Front Photo',
    },
    {
      id: '3',
      value: 'Vehicle Rear Photo',
    },
    {
      id: '4',
      value: 'Vehicle Side Photo',
    },
    {
      id: '5',
      value: 'Parts Photo',
    },
    {
      id: '6',
      value: 'Parts Sample',
    },
    {
      id: '7',
      value: 'Part No Required',
    },
    {
      id: '8',
      value: 'Parts Outdate',
    },
    {
      id: '9',
      value: 'Only Available in recon',
    },
  ];

  brandMaster = {
    1: 'Bajaj',
    2: 'Maruti',
    3: 'Skoda',
    4: 'Tata',
    5: 'Toyoto',
  };

  brandMasterList = [
    {
      id: '1',
      value: 'Bajaj',
    },
    {
      id: '2',
      value: 'Maruti',
    },
    {
      id: '3',
      value: 'Skoda',
    },
    {
      id: '4',
      value: 'Tata',
    },
    {
      id: '5',
      value: 'Toyoto',
    },
  ];

  vehicleTypeList = [
    { id: 1, value: '2W', label: '2 Wheeler (Bike)', capacity: '20 kg' },
    { id: 2, value: '3W', label: '3 Wheeler', capacity: '500 kg' },
    {
      id: 3,
      value: 'TATA_ACE_OPEN',
      label: 'Tata Ace (Open)',
      capacity: '750 kg',
    },
    {
      id: 4,
      value: 'TATA_ACE_ANY',
      label: 'Tata Ace (Any)',
      capacity: '750 kg',
    },
    {
      id: 5,
      value: 'TATA_ACE_CLOSED',
      label: 'Tata Ace (Closed)',
      capacity: '750 kg',
    },
    { id: 6, value: 'PICKUP_8FT', label: 'Pickup 8ft', capacity: '1200 kg' },
    { id: 7, value: 'TATA_407', label: 'Tata 407', capacity: '2500 kg' },
    { id: 8, value: 'TRUCK_14FT', label: '14ft Truck', capacity: '3500 kg' },
    { id: 9, value: 'TRUCK_17FT', label: '17ft Truck', capacity: '4500 kg' },
  ];

  deliveryTimeMapping: { [key: string]: string } = {
    'Same Day': '1',
    '1-2 days': '2',
    '3-5 days': '3',
    '7-15 days': '4',
  };

  otpConfig = {
    length: 6,
    allowNumbersOnly: true,
    inputStyles: {
      textAlign: 'center',
      borderRadius: '8px',
      border: '2px solid #ccc',
      transition: 'border-color 0.2s, box-shadow 0.2s',
    },
    containerStyles: {
      display: 'flex',
      gap: '12px',
      justifyContent: 'center',
      margin: '16px 0',
    },
    containerClass: 'otp-input-container',
    inputClass: 'otp-digit',
    showError: true,
  };

  showAddPriceModal = false;

  form = new FormGroup({});
  enquiry: any;
  enquiryDetails: any;
  partDetails: any;
  registerForm!: FormGroup;

  get priceDetails() {
    return this.registerForm.get('priceDetails') as FormArray;
  }
  get queryDetails() {
    return this.registerForm.get('queryDetails') as FormArray;
  }
  changeAddress() {
    this.showAddPriceModal = true;
  }
  onQueryTypeChange(event: any) {
    this.selectedQueryType = event.target.value;
  }
  get vehicleAttachmentDetails() {
    return this.registerForm.get('vehicleAttachmentDetails') as FormArray;
  }

  removeDocAttachment(index: number) {
    this.docAttachmentList.splice(index, 1);
  }

  onUploadDocTypeChange(event: any) {
    this.selectedDocAttachmentType = event.target.value;
  }

  get deliveryTypeLabel(): string {
    const val = this.registerForm.get('deliveryType')?.value;
    switch (val) {
      case '2':
        return 'Self Pickup';
      case '3':
        return 'Send Other Courier';
      default:
        return '';
    }
  }

  deletePOD() {
    if (!this.podDoc.id) return;

    this.podDoc = { id: '', url: '' };
    this.notify.showSuccess('POD deleted!', '');
  }

  newDocAttachment() {
    if (this.selectedDocAttachmentType) {
      const existingAttachment =
        this.basicDetails?.enquiryDetails?.sellerDoc?.find(
          (attachment) =>
            attachment.docType == Number(this.selectedDocAttachmentType)
        );

      console.log('existingAttachment', existingAttachment);
      if (existingAttachment) {
        this.notify.showError('Already Uploaded', '');
      } else {
        this.uploadDoc(2);
      }
    }
  }

  getAttachmentValue(attachmentTypeId: number): string {
    const attachment = this.vehicleDocList.find(
      (item) => item.id == attachmentTypeId
    );
    return attachment ? attachment.value : 'Unknown';
  }

  getDocAttachmentValue(attachmentTypeId: number): string {
    console.log('attachmentTypeId', attachmentTypeId);
    const attachment = this.orderDocQueryLists.find(
      (item) => item.id == attachmentTypeId
    );
    console.log('attachment', attachment);
    return attachment ? attachment.value : 'Unknown';
  }

  async viewAttachment(id: string, type: any) {
    if (type === 'vehicle') {
      const attachment = this.enquiry.vehicleAttachmentDetails.find(
        (item) => String(item.type) === String(id)
      );
      const attachmentUrl = attachment ? attachment.attachment : null;
      if (attachmentUrl) {
        const attachmentValue = this.getAttachmentValue(type);
        await this.showAlert(
          this.getAttachmentValue(attachment.type),
          `
          <div style="position: relative; width: 100%; text-align: center;">
            <img src="${attachment.attachment}" alt="Attachment" style="width: 100%; height: auto; display: block;" />
            <div style="position: absolute; top: 50%; left: 10px; transform: translateY(-50%); font-size: 24px; cursor: pointer;" id="left-arrow">
              &#9664;
            </div>
            <div style="position: absolute; top: 50%; right: 10px; transform: translateY(-50%); font-size: 24px; cursor: pointer;" id="right-arrow">
              &#9654;
            </div>
          </div>
        `
        );
      }
    } else if (type === 'part') {
      const attachment = this.enquiry.parts.find(
        (item) => String(item.id) === String(id)
      );
      const attachmentUrl = attachment ? attachment.image : null;
      if (attachmentUrl) {
        const attachmentValue = this.getAttachmentValue(type);
        await this.showAlert(
          this.getAttachmentValue(attachment.type),
          `
    <div class="image-container">
      <img src="${attachment.image}" alt="Attachment" class="attachment-image" />
      <ion-icon name="arrow-back-circle" class="arrow-icon left-arrow" (click)="onLeftArrowClick()"></ion-icon>
      <ion-icon name="arrow-forward-circle" class="arrow-icon right-arrow" (click)="onRightArrowClick()"></ion-icon>
    </div>
        `
        );
      }
    }
    return null;
  }

  async presentLoading() {
    const loading = document.createElement('div');
    loading.className = 'loading-overlay';
    loading.innerHTML = `
      <div class="loading-spinner"></div>
      <div class="loading-text">Uploading...</div>
    `;
    document.body.appendChild(loading);
    return {
      dismiss: () => {
        document.body.removeChild(loading);
      },
    };
  }

  // Add this method to create a basic form structure
  private initializeBasicForm() {
    this.registerForm = this.formBuilder.group({
      enqId: [null],
      status: [null],
      query: [null],
      replies: this.formBuilder.array([]),
      deliveryTime: [null],
      poNo: [null],
      deliveryType: [null],
      otp: [null],
      vehicleType: [null],
      priceDetails: this.formBuilder.array([this.createPriceFormGroup()]),
      queryDetails: this.formBuilder.array([this.createQueryFormGroup()]),
      vehicleAttachmentDetails: this.formBuilder.array([
        this.createVehAttachmentFormGroup(),
      ]),
    });
  }

  ngOnInit() {
    // this.loadEnquiryDetails();
    this.initializeEditPartForm();
    this.initEnquiryWatcher();
  }

  private startFancyLoader(): void {
    this.isInitialLoading = true;
    this.loaderTipIndex = 0;
    this.loaderProgress = 0;
    this.destroyLoader$.next(); // cancel previous if any

    // Tip rotation
    interval(1800)
      .pipe(takeUntil(this.destroyLoader$))
      .subscribe(() => {
        this.loaderTipIndex =
          (this.loaderTipIndex + 1) % this.loaderTips.length;
      });

    // Progress simulation
    interval(250)
      .pipe(takeUntil(this.destroyLoader$))
      .subscribe(() => {
        if (this.loaderProgress < 90) {
          this.loaderProgress += 3;
        }
      });
  }

  private stopFancyLoader(): void {
    this.destroyLoader$.next();
    this.loaderProgress = 100;
    setTimeout(() => (this.isInitialLoading = false), 250);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.destroyLoader$.next();
    this.destroyLoader$.complete();
    this.stopFancyLoader();
  }

  private initEnquiryWatcher(): void {
    this.route.paramMap
      .pipe(
        takeUntil(this.destroy$),
        map((pm) => pm.get('id')),
        filter((id) => !!id),
        distinctUntilChanged()
      )
      .subscribe((id) => {
        const numericId = Number(id);
        if (this.previousEnquiryId !== numericId) {
          this.resetEnquiryState();
          this.previousEnquiryId = numericId;
        }
        this.loadEnquiryDetails(numericId);
      });
  }

  private loadEnquiryDetails(enquiryId: number): void {
    this.startFancyLoader();
    this.orderAvailable = true;

    forkJoin({
      base: this.http.get(`retailers/getEnquiryDetail?enquiryId=${enquiryId}`),
      quotation: this.http.get(
        `retailers/getEnquiryAndQuotationDetails?enquiryId=${enquiryId}`
      ),
      brand: this.http.post('retailers/getOesBrandList', { enquiryId }),
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          // 1. Base enquiry
          if (res.base?.code === 1 && res.base.data) {
            this.enquiry = res.base.data;
          } else {
            this.stopFancyLoader();
            this.router.navigate(['/dashboard']);
            return;
          }

          // 2. Quotation / details
          if (res.quotation?.code === 1) {
            this.basicDetailsLoaded = true;
            this.basicDetails = res.quotation.data;

            // Attachments
            if (this.basicDetails?.enquiryDetails?.attachments) {
              this.vehicleAttachmentList =
                this.basicDetails.enquiryDetails.attachments.map(
                  (att: any) => ({
                    ...att,
                    attachmentType: att.type,
                  })
                );
            }

            // Delivery time mapping
            const dt = this.basicDetails?.enquiryDetails?.deliveryTime;
            if (dt) {
              const mapped = this.deliveryTimeMapping[dt] || '';
              this.registerForm.patchValue({ deliveryTime: mapped });
            }

            // Queries merge (avoid duplicates)
            if (this.basicDetails?.enquiryDetails?.queries) {
              const existing = new Set(
                this.querys.map((q) => q.queryType.toString())
              );
              const fresh = this.basicDetails.enquiryDetails.queries.filter(
                (q) => !existing.has(q.queryType.toString())
              );
              this.querys.push(...fresh);
            }

            this.totalAmount =
              this.basicDetails?.enquiryDetails?.totalAmount || 0;
          } else if (
            res.quotation?.code === 2 &&
            res.quotation?.message === 'Order Placed For Another Seller'
          ) {
            this.orderAvailable = false;
          }

          // 3. Brand list
          if (res.brand?.code === 1 && Array.isArray(res.brand.data)) {
            this.oesBrandList = res.brand.data.map((b: any) => ({
              id: b.id,
              title: b.title,
            }));
          } else {
            this.oesBrandList = [];
          }

          // 4. accType ensure
          if (this.enq.accType != null) {
            this.accType = this.enq.accType.toString();
          } else {
            const storedAccType = this.store.get('acc_type');
            this.accType =
              storedAccType !== undefined && storedAccType !== null
                ? storedAccType.toString()
                : '';
          }

          if (
            this.basicDetails?.enquiryDetails?.isOrderResubmit === 1 &&
            this.accType === '1'
          ) {
            this.showResubmitNotification();
          }

          // 5. Populate form
          this.initializeForm();
        },
        error: (err) => {
          console.error('Load error:', err);
          this.router.navigate(['/dashboard']);
        },
        complete: () => {
          this.stopFancyLoader();
          this.cdr.detectChanges();
        },
      });
  }

    showResubmitNotification() {
    const modalRef = this.modalService.open(ConfirmDialogComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.message =
      'Seller has updated the enquiry details. Please review the changes.';
    modalRef.componentInstance.button = 'OK';
  }

  private resetEnquiryState() {
    this.templateDownloaded = false;
    this.excelDataLoaded = false;
    this.selectedPrices = {};
    this.selectedReturnParts = {};
    this.debitNote = { no: '', id: '', url: '' };
    this.podDoc = { id: '', url: '' };
    this.showErrorBanner = false;
    this.selectedGlobalSellerId = null;
    this.deliveryTime = null;
    this.reqType = '1';

    // Reset form values
    if (this.registerForm) {
      this.registerForm.reset();

      // Reset FormArrays
      const priceDetails = this.registerForm.get('priceDetails') as FormArray;
      priceDetails.clear();
      priceDetails.push(this.createPriceFormGroup());

      const queryDetails = this.registerForm.get('queryDetails') as FormArray;
      queryDetails.clear();
      queryDetails.push(this.createQueryFormGroup());

      const vehicleAttachmentDetails = this.registerForm.get(
        'vehicleAttachmentDetails'
      ) as FormArray;
      vehicleAttachmentDetails.clear();
      vehicleAttachmentDetails.push(this.createVehAttachmentFormGroup());

      const replies = this.registerForm.get('replies') as FormArray;
      replies.clear();
    }

    // Reset other form-related properties
    this.partPriceList = {};
    this.querys = [];
    this.vehicleAttachmentList = [];
    this.docAttachmentList = [];
    this.updatedPartDetails = [];
    this.totalAmount = 0;
    this.totalSavings = 0;

    // Reset QueryForm
    if (this.QueryForm) {
      this.QueryForm.reset();
    }
  }

  async fetchOesBrandList(enquiryId: number) {
    try {
      const payload = { enquiryId };
      const res: any = await firstValueFrom(
        this.http.post('retailers/getOesBrandList', payload)
      );
      if (res.code === 1 && Array.isArray(res.data)) {
        // Store both id and title
        this.oesBrandList = res.data.map((item: any) => ({
          id: item.id,
          title: item.title,
        }));
      } else {
        this.oesBrandList = [];
        this.notify.showError(res.message || 'Failed to fetch OES brands', '');
      }
    } catch (error) {
      this.oesBrandList = [];
      this.notify.showError('Error fetching OES brands', '');
    }
  }

  // Add method to handle sort change
  async confirmSortChange(event: any) {
    const newValue = event.target.value;

    const modalRef = this.modalService.open(ConfirmDialogComponent, {
      centered: true,
    });

    modalRef.componentInstance.message = `Are you sure you want to sort by ${
      newValue === '1' ? 'best price' : 'fast delivery'
    }?`;
    modalRef.componentInstance.button = 'Confirm';

    try {
      const confirmed = await modalRef.result;
      if (confirmed) {
        this.updateSort(newValue);
      } else {
        // Revert to previous selection
        this.reqType =
          this.basicDetails?.enquiryDetails?.reqType?.toString() || '1';
      }
    } catch (dismissed) {
      // Modal was dismissed - revert to previous selection
      this.reqType =
        this.basicDetails?.enquiryDetails?.reqType?.toString() || '1';
    }
  }

  private async updateSort(newValue: string) {
    this.loadingService.show();

    try {
      // Call API with new sort value
      const response: any = await firstValueFrom(
        this.http.get(
          `retailers/getEnquiryAndQuotationDetails?enquiryId=${this.enquiry.enquiryId}&requestType=${newValue}`
        )
      );

      if (response && response.code === 1) {
        // Reset selected values and properties
        this.selectedPrices = {};
        this.selectedGlobalSellerId = null;
        this.deliveryTime = null;
        this.totalAmount = 0;
        this.totalSavings = 0;

        // Update basic details with new data
        this.basicDetails = response.data;
        this.reqType = newValue;

        // Reset part selections if they exist
        if (this.basicDetails?.enquiryDetails?.partDetails) {
          this.basicDetails.enquiryDetails.partDetails.forEach((part) => {
            if (part) {
              part.selectedSellerId = null;
            }
          });
        }

        this.notify.showSuccess(
          `Sorted by ${newValue === '1' ? 'best price' : 'fast delivery'}`,
          ''
        );
      } else {
        throw new Error(
          response?.message || 'Failed to update sort preference'
        );
      }
    } catch (error) {
      console.error('Sort error:', error);
      // Revert on error
      this.reqType =
        this.basicDetails?.enquiryDetails?.reqType?.toString() || '1';

      this.notify.showError('Failed to update sort preference', '');
    } finally {
      this.loadingService.hide();
    }
  }

  async reloadEnquiryDetails(enquiryId: number, reqType: string) {
    if (this.previousEnquiryId == enquiryId) {
      // Reset these only if enquiryId has changed
      this.templateDownloaded = false;
      this.excelDataLoaded = false;
      this.selectedPrices = {};
      this.selectedReturnParts = {};
      this.debitNote = {
        no: '',
        id: '',
        url: '',
      };
      this.podDoc = {
        id: '',
        url: '',
      };
      this.showErrorBanner = false;
      this.totalAmount = 0;
      this.selectedGlobalSellerId = null;
      this.deliveryTime = null;
      this.totalSavings = 0;
      this.reqType = reqType;

      // Reset part selections if they exist
      if (this.basicDetails?.enquiryDetails?.partDetails) {
        this.basicDetails.enquiryDetails.partDetails.forEach((part) => {
          if (part) {
            part.selectedSellerId = null;
          }
        });
      }
    }

    // Update the previous enquiryId for future comparisons
    this.previousEnquiryId = enquiryId;

    this.orderAvailable = true;
    // this.enquiryDetails = this.getEnqDetailsById(enquiryId);

    try {
      // Call API with new sort value
      const response = await this.http
        .get(
          `retailers/getEnquiryAndQuotationDetails?enquiryId=${enquiryId}&requestType=${reqType}`
        )
        .toPromise();

      if (response && response.code === 1) {
        // Reset selected values and properties
        this.selectedPrices = {};
        this.selectedGlobalSellerId = null;
        this.deliveryTime = null;
        this.totalAmount = 0;
        this.totalSavings = 0;

        // Update basic details with new data
        this.basicDetails = response.data;
        this.reqType = reqType;

        // Reset part selections if they exist
        if (this.basicDetails?.enquiryDetails?.partDetails) {
          this.basicDetails.enquiryDetails.partDetails.forEach((part) => {
            if (part) {
              part.selectedSellerId = null;
            }
          });
        }
      } else {
        this.notify.showSuccess(
          response?.message || 'Failed to fetch data',
          ''
        );
        throw new Error(response?.message || 'Failed to fetch data');
      }
    } catch (error) {
      this.notify.showError('Failed to fetch data', '');
    }

    this.basicDetails.enquiryDetails.reqType = reqType;
    console.log('bjhcbjhzbjhcjha:', this.basicDetails.enquiryDetails.reqType);
    this.reqType = reqType;
    console.log('Setting reqType to:', reqType);

    // Ensure accType is properly set
    if (this.enq.accType !== undefined && this.enq.accType !== null) {
      this.accType = this.enq.accType.toString();
    } else {
      const storedAccType = this.store.get('acc_type');
      this.accType =
        storedAccType !== undefined && storedAccType !== null
          ? storedAccType.toString()
          : '';
    }

    console.log('Final accType value:', this.accType);
    // this.initializeForm();
  }

  getEnqDetailsById(id: number) {
    console.log('enquiry', this.enquiry);
    this.http
      .get(`retailers/getEnquiryAndQuotationDetails?enquiryId=${id}`)
      .subscribe({
        next: (res: any) => {
          this.basicDetailsLoaded = true;
          if (res.code == 1) {
            this.basicDetails = res.data;

            if (this.basicDetails?.enquiryDetails?.attachments) {
              this.vehicleAttachmentList =
                this.basicDetails.enquiryDetails.attachments.map(
                  (att: any) => ({
                    ...att,
                    attachmentType: att.type,
                  })
                );
            }

            if (this.basicDetails?.enquiryDetails?.deliveryTime) {
              const mappedValue =
                this.deliveryTimeMapping[
                  this.basicDetails.enquiryDetails.deliveryTime
                ] || '';

              this.registerForm.patchValue({
                deliveryTime: mappedValue,
              });
            }

            if (this.basicDetails?.enquiryDetails?.queries) {
              const existingQueryTypes = new Set(
                this.querys.map((q) => q.queryType.toString())
              );

              const newQueries =
                this.basicDetails.enquiryDetails.queries.filter(
                  (q) => !existingQueryTypes.has(q.queryType.toString())
                );

              this.querys.push(...newQueries);

            }
            this.totalAmount = this.basicDetails?.enquiryDetails?.totalAmount;

          } else if (res.code == 2) {
            if (res.message == 'Order Placed For Another Seller') {
              this.orderAvailable = false;
            }
          }
        },
        error: (err) => {
          console.error('API Error:', err);

          // If HTML error page is returned
          const isHtmlError =
            err.error instanceof ProgressEvent ||
            (typeof err.error === 'string' && err.error.includes('<html'));

          if (err.status === 500 || isHtmlError) {
            this.showErrorBanner = true;
          }
        },
      });
  }

  // Rename and update the existing initializeForm method
  populateFormWithEnquiryData() {
    if (this.enquiry && this.registerForm) {
      // Update form with enquiry data
      this.registerForm.patchValue({
        enqId: this.enquiry.enquiryId,
        status: this.enquiry.statusCode,
      });

      // Handle delivery time if available
      if (this.basicDetails?.enquiryDetails?.deliveryTime) {
        const mappedValue =
          this.deliveryTimeMapping[
            this.basicDetails.enquiryDetails.deliveryTime
          ] || '';
        this.registerForm.patchValue({
          deliveryTime: mappedValue,
        });
      }

      // Handle replies for queries
      if (this.basicDetails?.enquiryDetails?.queries) {
        const repliesArray = this.registerForm.get('replies') as FormArray;
        repliesArray.clear();

        this.basicDetails.enquiryDetails.queries.forEach(() => {
          repliesArray.push(this.formBuilder.control(''));
        });
      }

      // Force change detection
      this.cdr.detectChanges();
    }
  }

  // Update the existing initializeForm method to use the new name
  initializeForm() {
    this.populateFormWithEnquiryData();
  }

  createVehAttachmentFormGroup() {
    return this.formBuilder.group({
      attachmentId: ['', Validators.required],
      attachment: [null],
    });
  }
  createPriceFormGroup() {
    return this.formBuilder.group({
      brand: [''],
      price: [''],
    });
  }
  createQueryFormGroup() {
    return this.formBuilder.group({
      remarks: [''],
      attachment: [''],
    });
  }
  addQuery() {
    const { type, remarks } = this.QueryForm.value;
    console.log('type', type);
    console.log('this.querys', this.querys);
    if (this.selectedQueryType) {
      const existingQuery = this.querys.find(
        (item) => String(item.queryType) === String(type)
      );
      if (existingQuery) {
        this.notify.showError('Already added', '');
      } else {
        const queryData = {
          queryType: type,
          remark: remarks,
        };
        this.querys.push(queryData);
        this.QueryForm.reset({ type: '', remarks: '' });
      }
    }
  }

  removeQuery(index: number) {
    this.querys.splice(index, 1);
  }
  getQuerlyValue(typeid: string): string {
    const query = this.queryList.find((item) => item.id === typeid);
    return query ? query.value : 'Unknown';
  }

  hasValidPartPriceList(): boolean {
    return Object.values(this.partPriceList).some(
      (arr) => Array.isArray(arr) && arr.length > 0
    );
  }

  getPrice(event: any, brand: any, partId: any, brandType: any) {
    // Handle both real events and fake events from onPriceChange
    const rawValue = event.target ? event.target.value : event.value || '';

    // Ensure we have a string and safely call trim
    const priceStr = String(rawValue || '').trim();
    const numericPrice = priceStr ? Number(priceStr) : 0;

    const newEntry = {
      brand: brand,
      price: numericPrice,
      type: Number(brandType),
      qty: 1, // Set default quantity or get from context if available
    };

    console.log('newEntry', newEntry);

    if (!this.partPriceList[partId]) {
      this.partPriceList[partId] = [];
    }

    const brandIndex = this.partPriceList[partId].findIndex(
      (entry) => entry.brand === brand
    );

    if (brandIndex === -1) {
      if (numericPrice > 0) {
        this.partPriceList[partId].push({
          ...newEntry,
          qty:
            this.basicDetails?.enquiryDetails?.partDetails?.find(
              (p) => p.enquiryPartId === partId
            )?.qty ?? 1,
        });
      }
    } else {
      if (numericPrice > 0) {
        this.partPriceList[partId][brandIndex].price = numericPrice;
      } else {
        this.partPriceList[partId].splice(brandIndex, 1);
      }
    }

    // Sort by type: 1 first, 2 second, 3 third
    this.partPriceList[partId].sort((a, b) => a.type - b.type);

    if (this.partPriceList[partId].length === 0) {
      delete this.partPriceList[partId];
    }

    console.log('Updated partPriceList', this.partPriceList);
  }

  getDeliveryTime(event: any, brand: any, partId: any, brandType: any) {
    const rawValue = event?.detail?.value ?? event?.target?.value ?? event;
    const selectedValue =
      rawValue !== null && rawValue !== undefined && rawValue !== ''
        ? Number(rawValue)
        : 0;

    if (!this.partPriceList[partId]) {
      this.partPriceList[partId] = [];
    }

    const brandIndex = this.partPriceList[partId].findIndex(
      (entry) => entry.brand === brand
    );

    if (brandIndex === -1) {
      if (selectedValue) {
        this.partPriceList[partId].push({
          brand: brand,
          price: 0,
          type: Number(brandType),
          qty:
            this.basicDetails?.enquiryDetails?.partDetails?.find(
              (p) => p.enquiryPartId === partId
            )?.qty ?? 1,
          deliveryTime: selectedValue,
        });
      }
    } else {
      if (selectedValue) {
        this.partPriceList[partId][brandIndex].deliveryTime = selectedValue;
      } else {
        delete this.partPriceList[partId][brandIndex].deliveryTime;
      }
    }

    this.partPriceList[partId].sort((a, b) => a.type - b.type);

    if (this.partPriceList[partId].length === 0) {
      delete this.partPriceList[partId];
    }

    console.log('Updated partPriceList with delivery time', this.partPriceList);
  }

  getExistingDeliveryTime(partId: number, brand: string, brandType: number): number | null {
    if (
      this.partPriceList &&
      this.partPriceList[partId] &&
      Array.isArray(this.partPriceList[partId])
    ) {
      const entry = this.partPriceList[partId].find(
        (item) => item.brand === brand && item.type === brandType
      );
      return entry && entry.deliveryTime ? entry.deliveryTime : null;
    }
    return null;
  }

  updatePricesFromExcel(): void {
    this.partPriceList = {}; // reset

    this.excelPreview.forEach((row) => {
      const pid = row.partId;
      this.partPriceList[pid] = [];

      // OE (MRP)
      if (row.oeMrp != null && row.oeMrp !== '') {
        this.partPriceList[pid].push({
          brand: String(this.basicDetails?.enquiryDetails?.make),
          price: Number(row.oeMrp),
          type: 1,
          qty: row.qty ? Number(row.qty) : 1,
        });
      }

      // OES Brand + OES(MRP)
      if (row.oesBrand && row.oesMrp != null && row.oesMrp !== '') {
        // Always store as string
        const brandName =
          typeof row.oesBrand === 'object'
            ? row.oesBrand.title
            : String(row.oesBrand);
        this.partPriceList[pid].push({
          brand: brandName,
          price: Number(row.oesMrp),
          type: 2,
          qty: row.qty ? Number(row.qty) : 1,
        });
      }

      // IMP (Landing Price)
      if (row.impLandingPrice != null && row.impLandingPrice !== '') {
        this.partPriceList[pid].push({
          brand: 'Imported', // Use 'Imported' for consistency
          price: Number(row.impLandingPrice),
          type: 3,
          qty: row.qty ? Number(row.qty) : 1,
        });
      }

      if (this.partPriceList[pid].length === 0) {
        delete this.partPriceList[pid];
      }
    });
  }

  logReply(event: any, type: any) {
    const input = (event.target as HTMLInputElement).value;
    const query = this.basicDetails?.enquiryDetails?.queries.find(
      (q) => q.type === type
    );
    query.reply = input;
  }

  hasDeliveryInfo(): boolean {
    const e = this.basicDetails?.enquiryDetails;
    const deliveryPerson =
      this.basicDetails?.enquiryDetails.deliveryPersonDetails[0];
    return !!(
      e?.orderId &&
      deliveryPerson &&
      deliveryPerson?.name &&
      deliveryPerson?.phoneNo &&
      deliveryPerson?.vehicleNo
    );
  }

  calculateTotalAmount() {
    // Calculate total amount
    this.totalAmount = Object.values(this.selectedPrices).reduce(
      (acc, item) => {
        return acc + item.sellingPrice * item.qty;
      },
      0
    );

    // Calculate total savings
    this.totalSavings = Object.values(this.selectedPrices).reduce(
      (acc, item) => {
        // Check if there's a price difference (MRP vs selling price)
        if (item.price && item.sellingPrice && item.price > item.sellingPrice) {
          const savings = (item.price - item.sellingPrice) * item.qty;
          return acc + savings;
        }
        return acc;
      },
      0
    );
  }

  f = (control) => this.registerForm.get(control) as FormControl;

  AddInfoReqSubmit() {
    this.isLoading = true;

    const { status, value } = this.registerForm;

    // Simple validation: ensure every query reply is present and not just whitespace
    const hasInvalidReply = this.basicDetails.enquiryDetails.queries?.some(
      (q) => !q.reply || q.reply.trim().length === 0
    );

    if (hasInvalidReply) {
      this.isLoading = false;
      this.notify.showError('Please write a reply for all queries.', '');
      return;
    }

    if (this.vehicleAttachmentList && this.vehicleAttachmentList.length > 0) {
      this.basicDetails.enquiryDetails.attachments =
        this.vehicleAttachmentList.map((attachment) => {
          return {
            attachmentId: attachment.attachmentId,
            type: attachment.type,
          };
        });
    }

    const resp = {
      basicDetails: this.basicDetails,
      priceDetails: this.selectedPrices,
      poNo: value.poNo,
      PoDocId: this.basicDetails?.enquiryDetails?.PoDocId,
    };
    this.http.post('retailers/buyerQueryReply', resp).subscribe({
      next: (res) => {
        this.isLoading = false;

        if (res.code == 1) {
          this.notify.showSuccess(res.message, '');
          this.router.navigate(['/dashboard']);
          this.enq.triggerRefreshList();
        } else {
          this.notify.showError(res.message, '');
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Submission Error:', err);
        this.notify.showError('An error occurred. Please try again.', '');
      },
    });
  }
  AddInfoReqSubmitBySeller() {
    this.isLoading = true;

    const { status, value } = this.registerForm;

    if (value.deliveryTime === null || value.deliveryTime === undefined) {
      this.isLoading = false;
      this.notify.showError('Please add Delivery Time.', '');
      return;
    }

    const resp = {
      updatedPartDetails: this.updatedPartDetails,
      enqDetails: this.enquiry,
      basicDetails: this.basicDetails,
      priceDetails: this.partPriceList,
      queryDetails: this.querys,
      deliveryTime: value.deliveryTime,
    };
    this.http.post('retailers/processAfterAddInfoBySeller', resp).subscribe({
      next: (res) => {
        this.isLoading = false;

        if (res.code == 1) {
          this.notify.showSuccess(res.message, '');
          this.router.navigate(['/dashboard']);
          this.enq.triggerRefreshList();
        } else {
          this.notify.showError(res.message, '');
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Submission Error:', err);
        this.notify.showError('An error occurred. Please try again.', '');
      },
    });
  }

  onEnqPriceSubmit(type: number) {
    this.showQueryModal = false;
    this.isLoading = true;

    const { status, value } = this.registerForm;
    let enqPriceResp;

    if (
      type == 1 &&
      (!this.partPriceList || Object.keys(this.partPriceList).length === 0)
    ) {
      this.isLoading = false;
      this.notify.showError('Please add at least one part price.', '');
      return;
    }

    if (type == 1) {
      enqPriceResp = {
        type: type,
        enqDetails: this.enquiry,
        priceDetails: this.partPriceList,
        queryDetails: this.querys,
        deliveryTime: value.deliveryTime,
        updatedPartDetails: this.updatedPartDetails,
      };
    } else {
      enqPriceResp = {
        type: type,
        enqDetails: this.enquiry,
        priceDetails: [],
        queryDetails: this.querys,
        deliveryTime: [],
        updatedPartDetails: this.updatedPartDetails,
      };
      this.enquiryDetails = this.getEnqDetailsById(this.enquiry.enquiryId);
    }
    console.log('enqPriceResp', enqPriceResp);
    this.http.post('retailers/saveSellerQuotation', enqPriceResp).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res.code == 1) {
          this.notify.showSuccess(res.message, '');
          if (type == 1) {
            this.router.navigate(['/dashboard']);
            this.enq.triggerRefreshList();
          }
        } else {
          this.notify.showError(res.message, '');
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Submission Error:', err);
        this.notify.showError('An error occurred. Please try again.', '');
      },
    });
  }

  onEnqRemainNotAvailable() {
    this.showQueryModal = false;

    const modalRef = this.modalService.open(ConfirmDialogComponent, {
      centered: true,
    });
    modalRef.componentInstance.message =
      'Are you sure Remaining parts are not available?';
    modalRef.componentInstance.button = 'Confirm';

    modalRef.result.then(
      (confirmed) => {
        if (confirmed) {
          this.isLoading = true;

          const enqPriceResp = {
            type: 1,
            enqDetails: this.enquiry,
            priceDetails: {},
            queryDetails: [],
            deliveryTime: '',
            updatedPartDetails: [],
          };

          console.log('enqPriceResp', enqPriceResp);
          this.http
            .post('retailers/saveSellerQuotation', enqPriceResp)
            .subscribe({
              next: (res) => {
                this.isLoading = false;
                if (res.code == 1) {
                  this.notify.showSuccess(res.message, '');
                  this.router.navigate(['/dashboard']);
                  this.enq.triggerRefreshList();
                } else {
                  this.notify.showError(res.message, '');
                }
              },
              error: (err) => {
                this.isLoading = false;
                console.error('Submission Error:', err);
                this.notify.showError('An error occurred. Please try again.', '');
              },
            });
        }
      },
      () => {
        // Modal dismissed (Cancel), do nothing
      }
    );
  }

  onEnqNotAvailable() {
    if (!this.enquiry?.enquiryId) {
      this.notify.showError('Enquiry ID is missing!', '');
      return;
    }

    const modalRef = this.modalService.open(ConfirmDialogComponent, {
      centered: true,
    });
    modalRef.componentInstance.message =
      'Are you sure you want to mark this as Not Available?';
    modalRef.componentInstance.button = 'Confirm';

    modalRef.result.then(
      (confirmed) => {
        if (confirmed) {
          this.isLoading = true;
          const enquiryId = this.enquiry.enquiryId;
          this.http
            .get(`retailers/partsNotAvailable/${enquiryId}`, {})
            .subscribe({
              next: (res: any) => {
                this.isLoading = false;

                if (res.code == 1) {
                  this.notify.showSuccess(res.message, '');
                  this.router.navigate(['/dashboard']);
                  this.enq.triggerRefreshList();
                } else {
                  this.notify.showError(res.message, '');
                }
              },
              error: (err) => {
                this.isLoading = false;
                console.error('Submission Error:', err);
                this.notify.showError(
                  'An error occurred. Please try again.',
                  ''
                );
              },
            });
        }
      },
      () => {
        // Modal was dismissed (Cancel), do nothing
      }
    );
  }

  async onEstimateSubmit() {
    this.isLoading = true;
    const { status, value } = this.registerForm;

    console.log('selectedPrices', this.selectedPrices);

    if (!this.selectedPrices || Object.keys(this.selectedPrices).length === 0) {
      this.notify.showError('Please add at least one Item', '');
      this.isLoading = false;
      return;
    }

    // if (!value.poNo || value.poNo.trim() === '') {
    //   this.notify.showError('Please fill PO No', '');
    //   this.isLoading = false;
    //   return;
    // }

    // if (!this.basicDetails?.enquiryDetails?.PoDocId) {
    //   this.notify.showError('Kindly Update PO Document', '');
    //   this.isLoading = false;
    //   return;
    // }

    // Get remaining items (items not selected)
    const remainingItems = this.getRemainingItems();

    let newEnquiry = null;

    if (remainingItems.length > 0) {
      this.isLoading = false;

      const modalRef = this.modalService.open(RegenerateItemModalComponent, {
        size: 'md',
        centered: true,
        backdrop: 'static',
        keyboard: false,
      });

      modalRef.componentInstance.remainingItems = remainingItems;

      try {
        const data = await modalRef.result;

        if (data) {
          const { selectedItems, needEnquiry } = data;

          if (needEnquiry && selectedItems && selectedItems.length > 0) {
            // User wants to create enquiry with selected items
            newEnquiry = this.buildNewEnquiryPayload(selectedItems);
          } else if (!needEnquiry) {
            // User skipped - continue without creating new enquiry
            newEnquiry = null; // Empty array
          } else {
            // User clicked create enquiry but no items selected (shouldn't happen due to disabled state)
            return;
          }
        } else {
          // Modal was dismissed without data (backdrop click, etc.)
          return;
        }
      } catch (dismissed) {
        // Modal was dismissed without data (backdrop click, etc.)
        return;
      }

      this.isLoading = true;
    }

    if (this.basicDetails?.enquiryDetails.reqType) {
      this.basicDetails.enquiryDetails.reqType = this.reqType;
    }

    const enqPriceResp = {
      basicDetails: this.basicDetails,
      // poNo: value.poNo,
      priceDetails: this.selectedPrices,
      PoDocId: this.basicDetails?.enquiryDetails?.PoDocId || null,
      newEnquiry: newEnquiry,
    };
    console.log('enqPriceResp', enqPriceResp);
    this.http.post('retailers/buyerOrder', enqPriceResp).subscribe({
      next: (res) => {
        this.isLoading = false;

        if (res.code == 1) {
          this.notify.showSuccess(res.message, '');
          this.router.navigate(['/dashboard']);
          this.enq.triggerRefreshList();
        } else if (res.code == 2) {
          const modalRef = this.modalService.open(ConfirmDialogComponent, {
            centered: true,
          });
          modalRef.componentInstance.message =
            'A better offer is available from another seller with more items at a lower total. Interested in viewing it?';
          modalRef.componentInstance.button = 'Yes, Show Me';

          modalRef.result.then(
            (confirmed) => {
              if (confirmed) {
                const enquiryId = this.previousEnquiryId;
                if (enquiryId) {
                  this.reloadEnquiryDetails(enquiryId, this.reqType || '1');
                }
              }
            },
            () => {
              // Modal was dismissed (Cancel), do nothing
            }
          );

          // else: do nothing, stay on the same page
        } else {
          this.notify.showError(res.message, '');
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Submission Error:', err);
        this.notify.showError('An error occurred. Please try again.', '');
      },
    });
  }

  buildNewEnquiryPayload(selectedItems: any[]) {
    const enquiryDetails = this.basicDetails?.enquiryDetails;

    // Map selected items to part details format
    const partDetails = selectedItems.map((item) => ({
      enquiryPartId: item.enquiryPartId,
      partDescription: item.partDescription,
      partNo: item.partNo,
      qty: item.qty,
      partAttachmentId: item.partAttachmentId || null,
      partImg: item.partImg || null,
    }));

    // Map existing vehicle attachments if they exist
    const vehicleAttachmentDetails = (enquiryDetails?.attachments || []).map(
      (attachment) => ({
        attachmentId: attachment.attachmentId,
        type: attachment.type,
        url: attachment.url,
      })
    );

    return {
      vehNo: enquiryDetails?.vehNo || '',
      chassisNo: enquiryDetails?.chassisNo || '',
      make: enquiryDetails?.makeId || '',
      model: enquiryDetails?.modelId || '',
      variant: enquiryDetails?.variantId || '',
      regDate: enquiryDetails?.regDate || '',
      fuelType: enquiryDetails?.fuelTypeId || '',
      location: enquiryDetails?.location || '',
      partType: enquiryDetails?.partType || '1',
      partDetails: partDetails,
      vehicleAttachmentDetails: vehicleAttachmentDetails,
      enquiryType: enquiryDetails?.enquiryType || '',
      isBulkUpload: enquiryDetails?.isBulkUpload || false,
    };
  }

  // Helper method to get remaining items
  getRemainingItems() {
    const allParts = this.basicDetails?.enquiryDetails?.partDetails || [];
    const balanceParts = this.basicDetails?.enquiryDetails?.balanceParts || [];
    const selectedPartIds = Object.keys(this.selectedPrices).map((id) =>
      parseInt(id)
    );

    // Get unselected parts from partDetails
    const unselectedParts = allParts
      .filter((part) => !selectedPartIds.includes(part.enquiryPartId))
      .map((part) => ({
        enquiryPartId: part.enquiryPartId,
        partDescription: part.partDescription,
        partNo: part.partNo,
        qty: part.qty,
        partAttachmentId: part.partAttachmentId || null,
        partImg: part.url || null,
        selected: false,
      }));

    // Get balance parts and format them
    const formattedBalanceParts = balanceParts.map((part) => ({
      enquiryPartId: part.enquiryPartId,
      partDescription: part.partDescription,
      partNo: part.partNo,
      qty: part.qty,
      partAttachmentId: part.partAttachmentId || null,
      partImg: part.url || null,
      selected: false,
    }));

    const combinedParts = [...unselectedParts, ...formattedBalanceParts];

    // Remove duplicates based on enquiryPartId
    const uniqueParts = combinedParts.filter(
      (part, index, self) =>
        index === self.findIndex((p) => p.enquiryPartId === part.enquiryPartId)
    );

     // Only include parts that have a non-empty partNo
    const uniquePartsWithPartNo = uniqueParts.filter(
      (part) => part.partNo && String(part.partNo).trim() !== ''
    );

    console.log('uniqueParts after deduplication', uniquePartsWithPartNo);

    return uniquePartsWithPartNo;
  }

  async showAddressModal() {
    const modalRef = this.modalService.open(AddressSelectionModalComponent, {
      size: 'md',
      backdrop: 'static',
    });
    modalRef.componentInstance.addresses =
      this.basicDetails?.enquiryDetails?.addresses;
    modalRef.componentInstance.defaultAddress =
      this.basicDetails?.enquiryDetails?.defaultSellerAddress[0];

    modalRef.result
      .then((data) => {
        if (data) {
          console.log('Selected address:', data);
          this.selectedAddress = data;
          this.pickupAddressId = data.id;
          // this.checkServiceAvailability(data);
        }
      })
      .catch(() => {
        // Modal dismissed without selection
      });
  }

  checkServiceAvailability(address: any) {
    const payload = {
      enquiryId: this.enquiry?.enquiryId,
      pickupAddressId: address.id,
      serviceDetails: this.basicDetails?.enquiryDetails?.serviceDetails?.[0],
    };

    this.serviceError = null;
    this.isLoading = true;
    this.isServiceable = false;

    this.http
      .post('retailers/checkServiceablePincodeForBothEcomAndPorter', payload)
      .subscribe({
        next: (res) => {
          this.isLoading = false;

          if (res.code === 1) {
            const porter = res.data?.porter;
            if (porter?.code === 1) {
              this.pickupAddressId = address.id;
              this.deliveryType = 1;
              this.isServiceable = true;
              this.serviceError = null;
            } else {
              this.isServiceable = false;
              this.serviceError =
                res.response?.message || 'Service not available.';
              // this.isServiceable = true;
              // this.serviceError = '';
              this.pickupAddressId = address.id;
            }
          } else {
            this.isServiceable = false;
            this.pickupAddressId = address.id;
            this.serviceError =
              res.response?.message || 'Service not available.';
          }
        },
        error: (err) => {
          this.isServiceable = false;
          this.isLoading = false;
          console.error('Submission Error:', err);
          this.serviceError = 'An error occurred. Please try again later.';
        },
      });
  }

  OnOrderSubmit() {
    this.isLoading = true;
    const { status, value } = this.registerForm;
    console.log('this.enquiry?.enqDetails', this.enquiry?.enquiryId);

    const sellerDocs = this.basicDetails?.enquiryDetails?.sellerDoc;

    const defaultAddress =
      this.basicDetails?.enquiryDetails?.isSellerAddressAvailable;


    // New check for defaultAddress
    if (defaultAddress === 2) {
      this.notify.showError(
        'Please update your address or contact support team and try again',
        ''
      );
      this.isLoading = false;
      return;
    }

    if (
      !sellerDocs ||
      sellerDocs.length === 0 ||
      !sellerDocs.some((doc) => doc.docType == 2)
    ) {
      this.notify.showError('Please upload Invoice Doc', '');
      this.isLoading = false;
      return;
    }

    if (!this.pickupAddressId) {
      this.notify.showError('Please select Pickup address', '');
      this.isLoading = false;
      return;
    }

    // ✅ Delivery Type Logic

    // const porterService =
    //   this.basicDetails?.enquiryDetails?.serviceDetails?.[0]?.porterService ??
    //   0;
    // let deliverytype = 3;

    // if (this.isServiceable) {
    //   if (porterService === 1) {
    //     deliverytype = 1;
    //   } else {
    //     deliverytype = 2;
    //   }
    // }

    // if (deliverytype == 1 && !value.vehicleType) {
    //   this.notify.showError('Please select vehicle type', '');
    //   this.isLoading = false;
    //   return;
    // }

    const enqPriceResp = {
      basicDetails: this.basicDetails,
      poNo: value.poNo,
      priceDetails: this.selectedPrices,
      pickupAddressId: this.pickupAddressId,
      // deliverytype: deliverytype,
      // vehicleType: value.vehicleType,
    };
    console.log('enqPriceResp', enqPriceResp);
    this.http.post('retailers/sellerDocSubmit', enqPriceResp).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res.code == 1) {
          this.notify.showSuccess(res.message, '');
          this.router.navigate(['/dashboard']);
          this.enq.triggerRefreshList();
        } else {
          this.notify.showError(res.message, '');
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Submission Error:', err);
        this.notify.showError('An error occurred. Please try again.', '');
      },
    });
  }

  OnReturnSubmit() {
    this.isLoading = true;
    const { status, value } = this.registerForm;
    console.log('this.enquiry?.enqDetails', this.enquiry?.enquiryId);

    if (!this.debitNote.id) {
      this.notify.showError('Please upload Debit Note Doc', '');
      this.isLoading = false;
      return;
    }

    const payload = {
      purchase_return_id: this.basicDetails.enquiryDetails.returnDetails[0].id,
      debitnote_no: this.debitNote.no,
      attachment_id: this.debitNote.id,
      partDetails: Object.values(this.selectedReturnParts),
    };
    console.log('payload', payload);
    this.http.post('retailers/purchaseReturnApproval', payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res.code == 1) {
          this.notify.showSuccess(res.message, '');
          this.router.navigate(['/dashboard']);
          this.enq.triggerRefreshList();
        } else {
          this.notify.showError(res.message, '');
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Submission Error:', err);
        this.notify.showError('An error occurred. Please try again.', '');
      },
    });
  }

  onReturnReject() {
    this.isLoading = true;
    const { status, value } = this.registerForm;
    console.log('this.enquiry?.enqDetails', this.enquiry?.enquiryId);

    const payload = {
      purchase_return_id: this.basicDetails.enquiryDetails.returnDetails[0].id,
    };
    console.log('payload', payload);
    this.http.post('retailers/purchaseReturnReject', payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res.code == 1) {
          this.notify.showSuccess(res.message, '');
          this.router.navigate(['/dashboard']);
          this.enq.triggerRefreshList();
        } else {
          this.notify.showError(res.message, '');
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Submission Error:', err);
        this.notify.showError('An error occurred. Please try again.', '');
      },
    });
  }

  confirmDispatch() {
    this.isLoading = true;
    const { status, value } = this.registerForm;

    const payload = {
      enquiryId: this.enquiry?.enquiryId,
      vehicleType: value.vehicleType,
    };

    this.http.post('retailers/processDeliveryDispatch', payload).subscribe({
      next: (res) => {
        this.isLoading = false;

        if (res.code == 1) {
          this.notify.showSuccess(res.message, '');
          this.router.navigate(['/dashboard']);
          this.enq.triggerRefreshList();
        } else {
          this.notify.showError(res.message, '');
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Submission Error:', err);
        this.notify.showError('An error occurred. Please try again.', '');
      },
    });
  }

  OnReceiveSubmit() {
    this.isLoading = true;
    const { status, value } = this.registerForm;
    console.log('this.enquiry?.enqDetails', this.enquiry?.enquiryId);
    const enqPriceResp = {
      basicDetails: this.basicDetails,
      poNo: value.poNo,
      priceDetails: this.selectedPrices,
    };
    console.log('enqPriceResp', enqPriceResp);
    this.http
      .post('retailers/buyerOrderReceiveSubmit', enqPriceResp)
      .subscribe({
        next: (res) => {
          this.isLoading = false;

          if (res.code == 1) {
            this.notify.showSuccess(res.message, '');
            this.router.navigate(['/dashboard']);
            this.enq.triggerRefreshList();
          } else {
            this.notify.showError(res.message, '');
          }
        },
        error: (err) => {
          this.isLoading = false;
          console.error('Submission Error:', err);
          this.notify.showError('An error occurred. Please try again.', '');
        },
      });
  }

  onPodSubmit() {
    this.isLoading = true;

    if (!this.podDoc.id) {
      this.notify.showError('Please upload POD Copy', '');
      this.isLoading = false;
      return;
    }

    const payload = {
      enquiryId: this.enquiry?.enquiryId,
      podId: this.podDoc.id,
    };

    this.http.post('retailers/savePodData', payload).subscribe({
      next: (res) => {
        this.isLoading = false;

        if (res.code == 1) {
          this.notify.showSuccess(res.message, '');
          this.router.navigate(['/dashboard']);
          this.enq.triggerRefreshList();
        } else {
          this.notify.showError(res.message, '');
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Submission Error:', err);
        this.notify.showError('An error occurred. Please try again.', '');
      },
    });
  }

  verifyOtp(deliveryType: string | number) {
    this.isLoading = true;
    const { status, value } = this.registerForm;

    if (!value.otp) {
      this.notify.showError('Please enter correct otp', '');
      this.isLoading = false;
      return;
    }

    const payload = {
      enquiryId: this.enquiry?.enquiryId,
      otp: value.otp,
    };

    let endpoint = '';
    if (deliveryType == '1' || deliveryType == 1) {
      endpoint = 'retailers/otpVerifcationToPorter';
    } else if (deliveryType == '2' || deliveryType == 2) {
      endpoint = 'retailers/otpVerifcationForSeller';
    } else {
      this.notify.showError('Invalid delivery type', '');
      this.isLoading = false;
      return;
    }

    this.http.post(endpoint, payload).subscribe({
      next: (res) => {
        this.isLoading = false;

        if (res.code == 1) {
          this.notify.showSuccess(res.message, '');
          this.router.navigate(['/dashboard']);
          this.enq.triggerRefreshList();
        } else {
          this.notify.showError(res.message, '');
          this.registerForm.get('otp')?.reset();
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Submission Error:', err);
        this.notify.showError('An error occurred. Please try again.', '');
      },
    });
  }

  onCheckboxChange(partId: any, brandDetails: any, qty: number, event: any) {
    const part = this.basicDetails.enquiryDetails.partDetails.find(
      (p) => p.enquiryPartId === partId
    );
    if (event.target.checked) {
      this.selectedPrices[partId] = {
        id: brandDetails.id,
        brand: brandDetails.brand,
        price: brandDetails.price,
        landingPrice: brandDetails.landingPrice,
        sellingPrice: brandDetails.sellingPrice,
        qty: qty,
        sellerId: brandDetails.sellerId,
        type: brandDetails.type,
      };
      part.selectedSellerId = brandDetails.sellerId;
      this.selectedGlobalSellerId = brandDetails.sellerId;
      this.deliveryTime = brandDetails.deliveryTime;
    } else {
      delete this.selectedPrices[partId];
      part.selectedSellerId = null;
      // If no part is selected, reset global seller id
      const anySelected = this.basicDetails.enquiryDetails.partDetails.some(
        (p) => p.selectedSellerId != null
      );
      if (!anySelected) {
        this.selectedGlobalSellerId = null;
        this.deliveryTime = null;
      }
    }
    this.calculateTotalAmount();
  }

  onReturnCheckboxChange(id: number, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
      this.selectedReturnParts[id] = { id };
    } else {
      delete this.selectedReturnParts[id];
    }
  }

  isSelected(partId: number, brand: any): boolean {
    return this.selectedPrices[partId]?.brand === brand;
  }

  isReturnSelected(id: number): boolean {
    return !!this.selectedReturnParts[id];
  }

  isAnyReturnSelected(): boolean {
    return Object.keys(this.selectedReturnParts).length > 0;
  }

  onUploadVehDocTypeChange(event: any) {
    this.selectedVehicleAttachmentType = event.target.value;
  }

  newVehicleAttachment() {
    if (this.selectedVehicleAttachmentType) {
      if (this.selectedVehicleAttachmentType == '5') {
        this.uploadImage();
      } else {
        const existingAttachment = this.vehicleAttachmentList.find(
          (attachment) =>
            attachment.attachmentType == this.selectedVehicleAttachmentType
        );
        if (existingAttachment) {
          this.notify.showError('Already Uploaded', '');
        } else {
          this.uploadImage();
        }
      }
    }
  }

  uploadImage() {
    // Create a file input element
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*'; // Accept only image files

    // Listen for changes (file selection)
    fileInput.onchange = async (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        const file = target.files[0];

        // Check if the file type is an image
        if (!file.type.startsWith('image/')) {
          this.notify.showError('Please select a valid image file.', '');
          return;
        }

        // Create a FileReader to read the file
        const reader = new FileReader();
        reader.onload = async (e) => {
          const imgSrc = e.target?.result as string;

          // Create an image element to load the captured image
          const img = new Image();
          img.src = imgSrc;

          img.onload = async () => {
            const canvas = document.createElement('canvas');
            const maxWidth = 800;
            const maxHeight = 800;

            let { width, height } = img;

            // Resize the image if it exceeds the maximum dimensions
            if (width > height && width > maxWidth) {
              height = Math.round((height * maxWidth) / width);
              width = maxWidth;
            } else if (height > maxHeight) {
              width = Math.round((width * maxHeight) / height);
              height = maxHeight;
            }

            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
            ctx?.drawImage(img, 0, 0, width, height);

            try {
              // Create a Blob from the canvas
              const blob = await this.createBlobFromCanvas(
                canvas,
                file.type,
                0.8
              );
              const formData = new FormData();
              formData.append('filename', blob, file.name);
              formData.append('type', this.selectedVehicleAttachmentType);
              formData.append('vehNo', this.registerForm.value.vehNo);

              // Show loading indicator
              this.loadingService.show();

              // Upload the image to the server
              const res: any = await firstValueFrom(
                this.http.filePost('retailers/enquiryImageUpload', formData)
              );

              if (res.code === 1) {
                const vehicleAttachment = {
                  attachmentType: this.selectedVehicleAttachmentType,
                  img: res.data.url,
                  attachmentId: res.data.attachmentId,
                };
                this.vehicleAttachmentList.push(vehicleAttachment);
                this.notify.showSuccess(res.message, '');
              } else {
                this.notify.showError(res.message, '');
              }
              this.loadingService.hide();
            } catch (blobError) {
              console.error('Blob creation error:', blobError);
              this.loadingService.hide();
              this.notify.showError('Error processing image.', '');
            }
          };
        };

        // Read the file as a Data URL
        reader.readAsDataURL(file);
      }
    };

    // Trigger the file input click
    fileInput.click();
  }

  createBlobFromCanvas(
    canvas: HTMLCanvasElement,
    type: string,
    quality: number
  ): Promise<Blob> {
    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error('Canvas is empty or conversion to Blob failed.'));
          }
        },
        type,
        quality
      );
    });
  }

  async showReturnPartDetailsAttachment(index: number, parts: any[]) {
    const partDetails =
      this.basicDetails?.enquiryDetails?.returnDetails[0].partDetetails;

    const validParts = partDetails.filter(
      (item) => item?.url && item?.url.trim() !== ''
    );

    const imageUrls = validParts.map((item) =>
      item?.url && item?.url.trim() !== ''
        ? item.url
        : 'assets/images/noimage.jpg'
    );

    const modalRef = this.modalService.open(AttachmentModalComponent, {
      size: 'lg',
      centered: true,
    });

    modalRef.componentInstance.images = imageUrls;
    modalRef.componentInstance.startIndex = index;
  }

  async showPartDetailsAttachment(index: number, parts) {
    const partDetails = this.basicDetails?.enquiryDetails?.partDetails;

    const validParts = partDetails.filter(
      (item) => item?.url && item?.url.trim() !== ''
    );

    const reorderedList = [
      ...validParts.slice(index),
      ...validParts.slice(0, index),
    ];

    const imageUrls = reorderedList.map((item) =>
      item?.url?.trim() !== '' ? item.url : 'assets/images/noimage.jpg'
    );

    const modalRef = this.modalService.open(AttachmentModalComponent, {
      size: 'lg',
      centered: true,
    });

    modalRef.componentInstance.images = imageUrls;
    modalRef.componentInstance.startIndex = 0;
  }

  async showVehicleAttachment(index: number, attachment: any) {
    window.open(attachment.url, '_blank');
  }

  async removeVehicleAttachment(index: number, attachmentId: string) {
    if (!attachmentId) {
      this.notify.showError('Invalid attachment ID', '');
      return;
    }

    const modalRef = this.modalService.open(ConfirmDialogComponent, {
      centered: true,
    });
    modalRef.componentInstance.message =
      'You are about to remove this attachment!';

    modalRef.result.then(
      (confirmed) => {
        if (confirmed) {
          this.http
            .get(`retailers/deleteEnquiryImage/${attachmentId}`)
            .subscribe({
              next: (res: any) => {
                if (res.code === 1) {
                  // Remove deleted attachment from the list
                  this.vehicleAttachmentList.splice(index, 1);
                  this.notify.showSuccess(res.message, '');
                } else {
                  this.notify.showError(res.message, '');
                }
              },
              error: (err) => {
                this.notify.showError(err.message, '');
              },
            });
        }
      },
      () => {
        // Modal was dismissed (Cancel), do nothing
      }
    );
  }

  async deleteAttachment(Id: string, type: number) {
    if (!Id) {
      this.notify.showError('Invalid document ID', '');
      return;
    }

    // Show confirmation dialog
    const modalRef = this.modalService.open(ConfirmDialogComponent, {
      centered: true,
    });
    modalRef.componentInstance.message =
      'Are you sure you want to delete this attachment?';

    try {
      const confirmed = await modalRef.result;
      if (!confirmed) return;

      this.http.get(`retailers/deleteDocuments/${Id}`).subscribe({
        next: (res) => this.handleDeleteResponse(res, Id, type),
        error: (err) =>
          this.notify.showError(err?.message || 'Delete failed', ''),
      });
    } catch {
      // dismissed, do nothing
    }
  }

  private handleDeleteResponse(res: any, Id: string, type: number) {
    if (res.code === 1) {
      this.updateModelsAfterDelete(Id, type, res.data);
      this.notify.showSuccess(res.message, '');
    } else {
      this.notify.showError(res.message, '');
    }
  }

  private updateModelsAfterDelete(Id: string, type: number, data: any) {
    const ed = this.basicDetails.enquiryDetails;

    if (type === 1) {
      ed.PoDocId = data?.documentId || null;
      ed.PoDoc = data?.url || null;
    } else if (type === 2 && ed.sellerDoc) {
      const idx = ed.sellerDoc.findIndex((doc) => doc.docId === Id);
      if (idx !== -1) ed.sellerDoc.splice(idx, 1);
    }
  }

  poUpload() {
    if (this.basicDetails?.enquiryDetails?.PoDocId) {
      this.notify.showError('Already Uploaded', '');
    } else {
      this.uploadDoc(1);
    }
  }

  uploadPOD() {
    if (this.basicDetails?.enquiryDetails?.PodDocId) {
      this.notify.showError('Already Uploaded', '');
    } else {
      this.uploadDoc(4);
    }
  }

  dnUpload() {
    this.uploadDoc(5);
  }

  async uploadDoc(type: number) {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = type === 1 ? '.pdf,.jpg,.jpeg,.png' : '.pdf';

    fileInput.onchange = async (event: any) => {
      const file = event.target.files[0];
      if (file) {
        const maxSize = 2 * 1024 * 1024; // 2MB
        if (file.size > maxSize) {
          this.notify.showError('File size must not exceed 2MB', '');
          return;
        }

        try {
          const formData = new FormData();
          formData.append('filename', file);
          formData.append(
            'type',
            type === 2 ? this.selectedDocAttachmentType : type.toString()
          );

          this.uploading = true;
          const loading = await this.presentLoading();

          const res: any = await firstValueFrom(
            this.http.filePost('retailers/documentUpload', formData)
          );

          if (res.code === 1) {
            if (type === 1) {
              this.basicDetails.enquiryDetails.PoDocId = res.data.documentId;
              this.basicDetails.enquiryDetails.PoDoc = res.data.url;
            } else if (type === 2) {
              this.basicDetails.enquiryDetails.sellerDoc =
                this.basicDetails.enquiryDetails.sellerDoc || [];
              this.basicDetails.enquiryDetails.sellerDoc.push({
                docType: this.selectedDocAttachmentType,
                docId: res.data.documentId,
                docUrl: res.data.url,
              });
            } else if (type === 5) {
              this.debitNote.id = res.data.documentId;
              this.debitNote.url = res.data.url;
            } else if (type === 4) {
              this.podDoc.id = res.data.documentId;
              this.podDoc.url = res.data.url;
            }

            this.notify.showSuccess(res.message, '');
          } else {
            this.notify.showError(res.message, '');
          }

          loading.dismiss();
        } catch (error) {
          console.error('Upload Error:', error);
          this.notify.showError('Error uploading document', '');
        } finally {
          this.uploading = false;
        }
      }
    };

    fileInput.click();
  }

  async viewPdf(url: string, file: string) {
    window.open(url, '_blank');
  }

  onPartNoChange(event: Event, partDetails: any): void {
    const inputElement = event.target as HTMLInputElement;
    const newPartNo = inputElement.value;

    this.updatedPartDetails.push({
      enquiryPartId: partDetails.enquiryPartId,
      partNo: newPartNo,
    });
  }

  showToast(message: string, type: 'success' | 'error' = 'success') {
    const toast = document.createElement('div');
    toast.className = `toast toast-${type}`;
    toast.textContent = message;
    document.body.appendChild(toast);

    setTimeout(() => {
      toast.classList.add('show');
    }, 10);

    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => {
        document.body.removeChild(toast);
      }, 300);
    }, 3000);
  }

  async showAlert(title: string, message: string): Promise<HTMLElement> {
    const overlay = document.createElement('div');
    overlay.className = 'alert-overlay';

    const alertBox = document.createElement('div');
    alertBox.className = 'alert-box';

    const titleEl = document.createElement('h3');
    titleEl.textContent = title;

    const messageEl = document.createElement('div');
    messageEl.innerHTML = message;

    const buttonContainer = document.createElement('div');
    buttonContainer.className = 'alert-buttons';

    const okBtn = document.createElement('button');
    okBtn.className = 'btn btn-primary';
    okBtn.textContent = 'OK';
    okBtn.onclick = () => {
      document.body.removeChild(overlay);
    };

    buttonContainer.appendChild(okBtn);

    alertBox.appendChild(titleEl);
    alertBox.appendChild(messageEl);
    alertBox.appendChild(buttonContainer);
    overlay.appendChild(alertBox);
    document.body.appendChild(overlay);

    return overlay;
  }

  getPartPrice(partId: number, brand: string): number {
    const partPrices = this.partPriceList[partId];
    if (partPrices) {
      const price = partPrices.find((p) => p.brand === brand);
      return price ? price.price : 0;
    }
    return 0;
  }

  async OnPurchaseReturnMake() {
    const modalRef = this.modalService.open(PurchaseReturnModalComponent, {
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      centered: true,
    });

    modalRef.componentInstance.parts =
      this.basicDetails?.enquiryDetails?.partDetails || [];
    modalRef.componentInstance.enquiry_id =
      this.basicDetails?.enquiryDetails?.enquiryId;
    modalRef.componentInstance.location_id =
      this.basicDetails?.enquiryDetails?.location;

    try {
      const result = await modalRef.result;

      if (result?.success) {
        console.log('Return submitted, refreshing...');

        this.enq.updateEnqDetail({
          statusId: 9,
          statusDescription: 'Return Raised',
        });

        this.loadEnquiryDetails(this.basicDetails?.enquiryDetails?.enquiryId); // 🔁 Re-initialize data
      } else {
        console.log('Modal closed without submission.');
      }
    } catch (dismissed) {
      console.log('Modal dismissed.');
    }
  }

  async openChatModal() {
    const modalRef = this.modalService.open(ChatModalComponent, {
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      centered: true,
    });

    modalRef.componentInstance.enquiryId =
      this.basicDetails?.enquiryDetails?.enquiryId;
  }

  downloadEnqTemplate() {
    const url = this.basicDetails?.enquiryDetails?.excelExport?.url;

    if (url) {
      const link = document.createElement('a');
      link.href = url;
      link.download = ''; // optional: specify a filename
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.templateDownloaded = true;
    } else {
      this.notify.showError('Excel file not available for download.', '');
    }
  }

  handleFileChange(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedExcelFile = file;
    }
  }

  onExcelUpload(): void {
    if (!this.selectedExcelFile) {
      alert('Please select a file first.');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const wb = XLSX.read(e.target.result, { type: 'binary' });
      const ws = wb.Sheets[wb.SheetNames[0]];

      // Use typed read to ensure output is an array of objects
      const rows = XLSX.utils.sheet_to_json<ExcelRow>(ws, {
        defval: '',
      }) as ExcelRow[];

      if (!Array.isArray(rows)) {
        console.error('Unexpected Excel format:', rows);
        return;
      }

      // Dynamically extract columns from the first row
      this.columns = Object.keys(rows[0]);

      // Optional: normalize column names (e.g., trim, remove spaces)
      this.columns = this.columns.map((col) => col.trim());

      this.excelPreview = rows.map((row) => {
        return {
          partId: row['Enquiry Part Id'] || '',
          partNo: row['Part No'] || '',
          partDescription: row['Description'] || '',
          qty: row['Qty'] || '',
          oe: row['OE(MRP)'] || '',
          oes: row['OES'] || '',
          oeMrp: row['OE(MRP)'] || '',
          oesBrand: row['OES Brand'] || '',
          oesId: row['OES ID'] || '',
          oesMrp: row['OES(MRP)'] || '',
          impLandingPrice: row['IMP(Landing Price)'] || '',
        };
      });

      this.excelDataLoaded = true;
      this.openExcelModal();
      console.log('Columns:', this.columns);
      console.log('Parsed Preview:', this.excelPreview);
    };

    reader.readAsBinaryString(this.selectedExcelFile);
  }

  isInvalid(row: any, col: string): boolean {
    if (col === 'partDescription') return !row[col];
    if (col === 'qty') return isNaN(Number(row[col]));
    if (col === 'oe') return !row[col];
    if (col === 'oes') return !row[col];
    return false;
  }

  openExcelModal() {
    if (this.excelPreview.length > 0) {
      this.modalService.open(this.excelPreviewModal, {
        size: 'lg',
        backdrop: 'static',
      });
    }
  }

  confirmExcelData(form: NgForm, modalRef: any) {
    this.updatePricesFromExcel();

    const partDetailsArr = this.basicDetails.enquiryDetails.partDetails;

    this.excelPreview.forEach((row) => {
      const priceDetails: any[] = [];

      // ✅ OE(MRP)
      if (row.oeMrp != null && row.oeMrp !== '') {
        priceDetails.push({
          brand: this.basicDetails.enquiryDetails.make, // main brand
          price: +row.oeMrp,
        });
      }

      // ✅ OES Brand + OES(MRP)
      if (row.oesBrand && row.oesMrp != null && row.oesMrp !== '') {
        priceDetails.push({
          brand: row.oesBrand, // e.g. SONALIKA
          price: +row.oesMrp,
        });
      }

      // ✅ IMP (Landing Price)
      if (row.impLandingPrice != null && row.impLandingPrice !== '') {
        priceDetails.push({
          brand: 'Imported',
          price: +row.impLandingPrice,
        });
      }

      // 🔁 Find matching object by enquiryPartId
      const part = partDetailsArr.find((p) => p.enquiryPartId === row.partId);
      if (part) {
        part.priceDetails = priceDetails.length ? priceDetails : null;
        // Patch OES brand as object from oesBrandList
        if (row.oesBrand) {
          const matchedBrand = this.oesBrandList.find(
            (b) => b.title?.toLowerCase() === String(row.oesBrand).toLowerCase()
          );
          part.oesBrand = matchedBrand || null;
        }
      } else {
        console.warn(`Part ID ${row.partId} not found; skipped.`);
      }
    });

    this.excelDataFetched = true;
    modalRef.close();
  }

  getExistingPrice(partId: number, brand: string, type: number): number {
    // const prices = this.partPriceList[partId];
    // const entry = prices?.find((p) => p.brand === brand);
    // return entry ? entry.price : null;

    const prices = this.partPriceList[partId];
    const entry = prices?.find((p) => p.type == type);
    return entry ? entry.price : null;
  }

  onPriceChange(value: string, brand: string, partId: number, type: number) {
    const fakeEvent = { value: value } as any;
    this.getPrice(fakeEvent, brand, partId, type);
  }

  clearSelectedExcelFile() {
    this.selectedExcelFile = null;
    this.excelPreview = [];
    this.excelDataLoaded = false;
  }

  onOesBrandChange(part: any) {
    if (!part.oesBrand) {
      part.oesBrand = this.oesBrandList[0]; // default first option
    }
  }

  getSortedPriceDetails(part: any): any[] {
    return (part?.priceDetails || [])
      .slice(0)
      .sort((a: any, b: any) => Number(a.type) - Number(b.type));
  }

  // Add this method to your component class
  isDeliveryTimeMultiple(deliveryTime: any): boolean {
    return Array.isArray(deliveryTime) && deliveryTime.length > 1;
  }

  getDiscount(mrp: number, offer: number): number {
    if (!mrp || !offer || mrp <= offer) return 0;
    return Math.round(((mrp - offer) / mrp) * 100);
  }
  getSave(mrp: number, offer: number): number {
    if (!mrp || !offer || mrp <= offer) return 0;
    return mrp - offer;
  }

  getDiscountPercentage(original: number, discounted: number): number {
    if (!original || !discounted || original <= discounted) return 0;
    return Math.round(((original - discounted) / original) * 100);
  }

  getDeliveryTimeLabel(deliveryTime: number): string {
    if (!deliveryTime) return '-';
    
    if (deliveryTime === 1) {
      return 'Same Day';
    } else if (deliveryTime <= 2) {
      return `${deliveryTime} days`;
    } else if (deliveryTime <= 5) {
      return `${deliveryTime} days`;
    } else {
      return `${deliveryTime} days`;
    }
  }

  // Initialize Edit Part Form
  private initializeEditPartForm(): void {
    this.editPartForm = this.formBuilder.group({
      partNo: ['', [Validators.required]],
      partDescription: [''],
      qty: ['', [Validators.required, Validators.min(1)]],
      price: [''],
      enquiryPartId: [''],
      quotationPartId: [''],
      make: [''],
    });
  }

  // Handle Part No Input
  onPartNoInput(event: any): void {
    const value = event.target?.value || '';
    
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    
    if (value && value.trim().length >= 3) {
      this.searchTimeout = setTimeout(() => {
        this.searchPartItems(value);
      }, 300);
    } else {
      this.partItemsList = [];
      this.showPartSuggestions = false;
    }
  }

  // Hide Suggestions
  hideSuggestions(): void {
    setTimeout(() => {
      this.showPartSuggestions = false;
    }, 200);
  }

  // Search Part Items from API
  searchPartItems(keyword: string): void {
    this.partSearchLoading = true;
    this.http.get(`retailers/getPartItems?keyword=${keyword}`).subscribe(
      (response: any) => {
        this.partSearchLoading = false;
        if (response.code === 1 && response.data) {
          this.partItemsList = response.data;
          this.showPartSuggestions = this.partItemsList.length > 0;
        } else {
          this.partItemsList = [];
          this.showPartSuggestions = false;
        }
      },
      (error: any) => {
        this.partSearchLoading = false;
        console.error('Error searching part items:', error);
        this.partItemsList = [];
        this.showPartSuggestions = false;
      }
    );
  }

  // Select Part Item from Suggestions
  selectPartItem(partItem: any): void {
    this.editPartForm.patchValue({
      partNo: partItem.part_no,
      partDescription: partItem.description,
      price: partItem.mrp,
    });
    this.partItemsList = [];
    this.showPartSuggestions = false;
  }

  // Open Edit Part Modal
  openEditPartModal(index: number, part: any): void {
    this.selectedPartIndex = index;
    this.selectedPart = { ...part };
    this.editError = '';
    this.partItemsList = [];
    this.showPartSuggestions = false;

    this.editPartForm.reset();

    // Populate form with current values
    this.editPartForm.patchValue({
      enquiryPartId: part.enquiryPartId,
      quotationPartId: part.quotationPartId,
      make: part.make,
      qty: part.qty,
      price: part.price,
    });

    // Open modal
    this.modalService.open(this.editPartModal, {
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      centered: true,
      windowClass: 'edit-part-modal'
    });
  }

 // Save Edited Part (Updated - No API call, just push to array)
  saveEditedPart(modal: any): void {
    if (!this.editPartForm.valid) {
      this.editError = 'Please fill all required fields';
      return;
    }

    // Find the quotation part ID and make from basicDetails
    const quotationPartId = this.basicDetails?.enquiryDetails?.partDetails[this.selectedPartIndex]?.quotationPartId;
    const make = this.basicDetails?.enquiryDetails?.make;

    // Create edited part object
    const editedPart = {
      enquiryPartId: this.selectedPart?.enquiryPartId,
      quotationPartId: quotationPartId,
      partNo: this.editPartForm.get('partNo').value,
      partDescription: this.editPartForm.get('partDescription').value,
      qty: this.editPartForm.get('qty').value,
      make: make,
      price: this.editPartForm.get('price').value,
    };

    // Check if this part is already in the array
    const existingIndex = this.editedParts.findIndex(
      (p) => p.enquiryPartId === editedPart.enquiryPartId
    );

    if (existingIndex !== -1) {
      // Update existing part
      this.editedParts[existingIndex] = editedPart;
      this.notify.showSuccess('Part updated in list', '');
    } else {
      // Add new edited part
      this.editedParts.push(editedPart);
      this.notify.showSuccess('Part added to edit list', '');
    }

     // Update local data immediately
    const updatedPart = {
      ...this.basicDetails.enquiryDetails.partDetails[this.selectedPartIndex],
      partNo: this.editPartForm.get('partNo').value,
      partDescription: this.editPartForm.get('partDescription').value,
      qty: this.editPartForm.get('qty').value,
      landingPrice: this.editPartForm.get('price').value,
    };

    this.basicDetails.enquiryDetails.partDetails[this.selectedPartIndex] = updatedPart;

    // Close modal
    modal.dismiss();
    
    // Reset form and state
    this.clearEditPartModalState();

    console.log('Edited parts array:', this.editedParts);
  }

  // Clear modal state
  clearEditPartModalState(): void {
    this.selectedPart = null;
    this.selectedPartIndex = null;
    this.editError = '';
    this.partItemsList = [];
    this.showPartSuggestions = false;
    this.partSearchLoading = false;
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.editPartForm.reset();
  }

   // New method to submit all edited parts at once
  submitAllEditedParts(): void {
    if (this.editedParts.length === 0) {
      this.notify.showError('No parts to update', '');
      return;
    }

    this.isLoading = true;
    const enquiryId = this.enquiry?.enquiryId;

    const payload = {
      enquiryId: enquiryId,
      quotationId: this.basicDetails?.enquiryDetails?.partDetails[0]?.quotationId,
      updatedPartDetails: this.editedParts
    };

    console.log('Submitting all edited parts:', payload);

    this.http.post('retailers/orderResubmit', payload).subscribe(
      (response: any) => {
        this.isLoading = false;
        if (response.code === 1) {
          this.notify.showSuccess(
            `${this.editedParts.length} part(s) updated successfully`,
            ''
          );
          this.router.navigate(['/dashboard']);
          this.enq.triggerRefreshList();
        } else {
          this.notify.showError(response?.message || 'Failed to update parts', '');
        }
      },
      (error: any) => {
        this.isLoading = false;
        const errorMsg = error?.error?.message || 'Failed to update parts';
        this.notify.showError(errorMsg, '');
        console.error('Error updating parts:', error);
      }
    );
  }

  // Method to clear edited parts array
  clearEditedParts(): void {
    const modalRef = this.modalService.open(ConfirmDialogComponent, {
      centered: true,
    });
    modalRef.componentInstance.message = 'Are you sure you want to discard all edits?';
    modalRef.componentInstance.button = 'Confirm';

    modalRef.result.then(
      (confirmed) => {
        if (confirmed) {
          this.editedParts = [];
          this.notify.showSuccess('All edits discarded', '');
          // Reload to reset local changes
          this.loadEnquiryDetails(this.enquiry?.enquiryId);
        }
      },
      () => {
        // Modal dismissed
      }
    );
  }

  // Get count of edited parts
  getEditedPartsCount(): number {
    return this.editedParts?.length || 0;
  }

  // Check if a part has been edited
  isPartEdited(enquiryPartId: number): boolean {
    return this.editedParts.some((p) => p.enquiryPartId === enquiryPartId);
  }

  getCalculatedTotalAmount(): number {
    if (!this.basicDetails?.enquiryDetails?.partDetails) return 0;

    return this.basicDetails.enquiryDetails.partDetails.reduce((total: number, part: any) => {
      // Use landingPrice if available, otherwise fallback to price
      const price = part.landingPrice ? Number(part.landingPrice) : (Number(part.price) || 0);
      const qty = Number(part.qty) || 0;
      return total + (price * qty);
    }, 0);
  }

  openChangeAddressModal() {
    
  }


}
